import type { AbstractControl, ValidationErrors } from '@angular/forms';
import { HausratSchadenart } from '../../interfaces';

/** The Sparte takes a Schadenhöhe of 1 to 999.999 €. */
export const SCHADENHOEHE_MIN = 1;
export const SCHADENHOEHE_MAX = 999999;

/** Elementar und Starkregen reach ten years back, every other Schadenart five. */
const JAHRE_ZURUECK_ELEMENTAR = 10;
const JAHRE_ZURUECK_SONST = 5;

const LANGER_RUECKBLICK: ReadonlyArray<HausratSchadenart> = [
  HausratSchadenart.Elementar,
  HausratSchadenart.Starkregen,
];

/** The oldest and newest Jahr a Schaden of this Art may be reported for. */
export function vorschadenJahrRange(art: HausratSchadenart | null | undefined): {
  min: number;
  max: number;
} {
  const max = new Date().getFullYear();
  const jahreZurueck =
    art != null && LANGER_RUECKBLICK.includes(art) ? JAHRE_ZURUECK_ELEMENTAR : JAHRE_ZURUECK_SONST;

  return { min: max - jahreZurueck, max };
}

/**
 * Reads the Schadenart off the sibling control, so the window widens to ten years the moment the
 * customer picks Elementar or Starkregen.
 */
export function vorschadenJahrValidator(control: AbstractControl): ValidationErrors | null {
  if (typeof control.value !== 'number') return null;

  const art = control.parent?.get('art')?.value as HausratSchadenart | null | undefined;
  const { min, max } = vorschadenJahrRange(art);

  if (control.value < min) return { min: { min, actual: control.value } };
  if (control.value > max) return { max: { max, actual: control.value } };
  return null;
}
